import { MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, Menu } from "antd";
import React, { useState } from "react";
import add from "../../assets/Icons/addBtnIcon.svg";
import { ReactComponent as Edit } from "../../assets/Icons/portfolioEditIcon.svg";
import { ReactComponent as Trash } from "../../assets/Icons/portfolioTrashIcon.svg";

import NormalButton from "../../Reuseable/NormalButton/NormalButton";
import ReusableTable from "../../Reuseable/ReusableTable/ReusableTable";
import "./TargetAchivementsPage.scss";
import DeleteUserModal from "../../components/AgencyComp/UserComp/DeleteUserModal";
import TargetAchievementsModal from "../../components/TargetAchivements/TargetAchievementsModal/TargetAchievementsModal";
import { useNavigate } from "react-router-dom";

const TargetAchievementsPage = () => {
  const [pageSize, setPageSize] = useState(10);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const navigate = useNavigate();
  const handleEditClick = (record) => {
    setSelectedRecord(record);
    setIsEditModalOpen(true);
  };

  const handleDeleteClick = (record) => {
    setSelectedRecord(record);
    setIsDeleteModalOpen(true);
  };

  const handleSave = (updatedData) => {

    // TODO: Update state or make API call
  };

  const handleDelete = () => {

    // TODO: Delete logic here (e.g., filter out record or API call)
  };

  const columns = [
    {
      title: "Users",
      dataIndex: "user",
      key: "user",
    },
    {
      title: "Target",
      dataIndex: "target",
      key: "target",
    },
    {
      title: "Achievement",
      dataIndex: "targetValue",
      key: "targetValue",
      align: "center",
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => {
        const menu = (
          <Menu className="actionMenuWrapper">
            <Menu.Item key="edit" onClick={() => handleEditClick(record)}>
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Edit />
                Edit
              </span>
            </Menu.Item>
            <Menu.Item key="delete" onClick={() => handleDeleteClick(record)}>
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <Trash />
                Delete
              </span>
            </Menu.Item>
          </Menu>
        );

        return (
          <Dropdown overlay={menu} trigger={["click"]}>
            <Button
              type="text"
              icon={<MoreOutlined />}
              onClick={(e) => e.stopPropagation()}
            />
          </Dropdown>
        );
      },
    },
  ];

  const getCurrentDate = () => {
    const today = new Date();
    return today.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const getMonthEndDate = () => {
    const today = new Date();
    const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return endOfMonth.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const data = [
    {
      key: "1",
      user: "Abhimanu Gamane",
      target: 0,
      targetValue: 0,
    },
    {
      key: "2",
      user: "Annu Harishankar chauhan",
       target: 0,
      targetValue: 0,
    },
    {
      key: "3",
      user: "ashish",
      target: 0,
      targetValue: 0,
    },
    {
      key: "4",
      user: "George_HC",
       target: 0,
      targetValue: 0,
    },
    {
      key: "5",
      user: "Priti Rakesh Yadav",
       target: 0,
      targetValue: 0,
    },
  ].map(item => ({
    ...item,
    startDate: getCurrentDate(),
    endDate: getMonthEndDate(),
  }));



  return (
    <div className="targetAchievementsMain">
      <div className="addBtn">
        <NormalButton
          onClick={() => navigate("/target-achievement/add-new-target")}
        >
          <img src={add} alt="" />
          Add New Target
        </NormalButton>
      </div>
      <ReusableTable
        columns={columns}
        dataSource={data}
        pageSize={pageSize}
        setPageSize={setPageSize}
        totalItems={data.length}
      />

      <TargetAchievementsModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        userData={selectedRecord}
        onSave={handleSave}
      />

      {/* Delete Modal */}
      <DeleteUserModal
        open={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onDelete={() => {
          handleDelete();
          setIsDeleteModalOpen(false);
        }}
      />
    </div>
  );
};

export default TargetAchievementsPage;
